class VtFaq extends HTMLElement {
  connectedCallback() {
    this.items = Array.from(this.querySelectorAll('.vt-faq__item'));
    this.buttons = Array.from(this.querySelectorAll('.vt-faq__summary'));

    this.buttons.forEach((button) => {
      button.addEventListener('click', () => this.toggle(button));
    });
  }

  toggle(button) {
    const item = button.closest('.vt-faq__item');
    const panel = item.querySelector('.vt-faq__panel');
    const willOpen = !item.classList.contains('is-open');

    this.items.forEach((other) => {
      const otherButton = other.querySelector('.vt-faq__summary');
      const otherPanel = other.querySelector('.vt-faq__panel');
      const isTarget = other === item && willOpen;

      other.classList.toggle('is-open', isTarget);
      otherButton.setAttribute('aria-expanded', isTarget ? 'true' : 'false');
      otherPanel.setAttribute('aria-hidden', isTarget ? 'false' : 'true');
    });
  }
}

customElements.define('vt-faq', VtFaq);
